import { mix_match_response } from "./../models/baske.model";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "./api.service";
import { Observable, BehaviorSubject, Subscription } from "rxjs";
import { Basket } from "../models/baske.model";
import { BasketItem } from "../models/basketitem.model";
import { User } from "../models/Userverify.model";
import { selectMerchant } from "src/app/store/selectors/merchant.selector";
import { select, Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app.state";
import { GetCategories } from "src/app/store/actions/category.actions";
import { API } from "./paymentapiroutes";
import { Merchant } from "../models/merchant";
import { split } from "cypress/types/lodash";
import { hostname } from "os";
import { common, MultiOutletLocation } from "../helpers/helper.common";
import { basketService } from "./basket.service";
declare function ConvertHexaToImageForground(HexaColor, callback): any;
@Injectable({
  providedIn: "root",
})
// CoreService class to manage shared data and functionality across the application
export class CoreService {
  // Stores the previous URL visited by the user
  public previousUrl: string;

  // Stores the current URL being visited by the user
  public currentUrl: string;

  // Stores the current static URL
  public stcurrentUrl: string;

  // BehaviorSubject to manage the visibility of the loader
  showLoader = new BehaviorSubject<boolean>(false);

  // BehaviorSubject to manage the user's shopping basket
  basketSubject = new BehaviorSubject<Basket>(null);

  // Observable for the user's shopping basket
  basket$ = this.basketSubject.asObservable();

  // BehaviorSubject to manage mix and match responses
  mixandmatchSubject = new BehaviorSubject<mix_match_response>(null);

  // Observable for selected mix and match responses
  selectedmixandmatch$ = this.mixandmatchSubject.asObservable();

  // Observable for merchant data
  Merchant$ = this._store.pipe(select(selectMerchant));

  // BehaviorSubject to manage the selected merchant
  MerchantSubject = new BehaviorSubject<Merchant>(null);

  // BehaviorSubject to manage image color changes
  ImageColorSubject = new BehaviorSubject<string>(null);

  TilePinColor = new BehaviorSubject<string>(null);

  ButtonColor = new BehaviorSubject<string>(null);

  DarkFontColor = new BehaviorSubject<string>(null);

  // Observable for image color changes
  ImageColor$ = this.ImageColorSubject.asObservable();

  TilePin$ = this.TilePinColor.asObservable();

  ButtonColor$ = this.ButtonColor.asObservable();

  DarkFontColor$ = this.DarkFontColor.asObservable();

  // BehaviorSubject to manage user data
  UserSub = new BehaviorSubject<User>(
    JSON.parse(localStorage.getItem("currentUser")),
  );

  // Observable for user data
  User = this.UserSub.asObservable();

  // Stores the current shopping basket
  currentBasket: Basket;

  // Subscription for merchant data
  subscription: Subscription;

  locationData: any;

  // Static property to track multi-outlet setting
  static MultiOutlet: number = 0;
  static MultiOutletId: number = 0;

  private deferredPrompt: any = null;
  public isStandalone = false;

  constructor(
    private apiService: ApiService,
    private basketService: basketService,
    private commonService: common,
    private _store: Store<IAppState>,
    private router: Router,
  ) {
    // Subscribe to the Merchant$ observable to handle merchant data changes
    this.subscription = this.Merchant$.subscribe((data) => {
      // Check if the data has multi-outlet setting
      if (data && data.multi_outlet) {
        // Convert hex color to image foreground color and update the subject
        ConvertHexaToImageForground(data.menu_border_color, (response) => {
          this.ImageColorSubject.next(response);
        });

        ConvertHexaToImageForground(data.tile_text_color, (response) => {
          this.TilePinColor.next(response);
        });

        ConvertHexaToImageForground(
          data.menu_font_color_allpage,
          (response) => {
            this.DarkFontColor.next(response);
          },
        );

        // Update the MerchantSubject with data
        this.MerchantSubject.next(data);
        // Update MultiOutlet and create a dynamic PWA manifest
        CoreService.MultiOutlet = data.multi_outlet;
        CoreService.MultiOutletId = data.id;
        this.CreateDynamicPWAManifest(
          data.multioutlet_name,
          data.multioutlet_headerLogo || data.headerLogo || data.logo,
          data.menu_color,
          data.menu_border_color,
          window.location.href,
        );

        // Navigate to the root URL
        this.navigateTo("/", null, true);
      }

      // Handle cases where data is available but not a multi-outlet
      else if (data && data.id) {
        // Store retailer ID and convert hex color to image foreground color
        localStorage.setItem("retailer_id", data.id.toString());
        ConvertHexaToImageForground(
          data.webapp_settings?.menu_color,
          (response) => this.ImageColorSubject.next(response),
        );

        ConvertHexaToImageForground(
          data.webapp_settings?.menu_font_color_homepgae,
          (response) => {
            this.ButtonColor.next(response);
          },
        );

        ConvertHexaToImageForground(
          data.webapp_settings?.menu_font_color_allpage,
          (response) => {
            this.DarkFontColor.next(response);
          },
        );

        // Update retailer ID and create a dynamic PWA manifest
        CoreService.retailerId = data.id;
        // var startURl = window.location.href;
        const startUrl = new URL(window.location.href).origin;

        // this.CreateDynamicPWAManifest(
        //   data.name,
        //   data.logo,
        //   data.webapp_settings?.menu_color,
        //   data.webapp_settings?.menu_border_color,
        //   startURl,
        // );

        this.CreateDynamicPWAManifest(
          data.multioutlet_name || data.name,
          data.multioutlet_name ? data.multioutlet_headerLogo : data.logo,
          data.multioutlet_name
            ? data.multioutlet_menu_color
            : data.webapp_settings?.menu_color,
          data.multioutlet_name
            ? data.multioutlet_menu_border_color
            : data.webapp_settings?.menu_border_color,
          startUrl,
        );

        // Dispatch action to get categories and navigate to dashboard
        this._store.dispatch(new GetCategories(data.id.toString()));
        if (!CoreService.MultiOutlet) this.navigateTo("/dashboard", null, true);
        this.MerchantSubject.next(data);
      }
      // Handle cases where data has a deeplink
      else if (data && data.deeplink) {
        this.navigateTo("/dashboard", null, true);
      }
      // Handle cases where data has an error
      else if (data && data.error && !data.success) {
        this.navigateTo("websitenotfound");
      }

      this.initializePWA();
    });

    // Subscribe to the basket$ observable to manage the current shopping basket
    this.basket$.subscribe((data) => {
      this.currentBasket = data;
    });
  }

  initializePWA(): void {
    console.log("Initializing PWA installation logic...");
    // Detect installed app
    this.isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;

    // Android install event
    window.addEventListener("beforeinstallprompt", (event: any) => {
      console.log("beforeinstallprompt fired");
      event.preventDefault();

      this.deferredPrompt = event;

      console.log("PWA install available");
    });

    window.addEventListener("appinstalled", () => {
      console.log("PWA Installed");

      this.deferredPrompt = null;

      this.isStandalone = true;
    });
  }

  async installPWA() {
    if (!this.deferredPrompt) {
      console.log("Install prompt not available");
      return;
    }

    this.deferredPrompt.prompt();

    const result = await this.deferredPrompt.userChoice;

    console.log(result.outcome);

    this.deferredPrompt = null;
  }

  get canInstallAndroid(): boolean {
    return !!this.deferredPrompt;
  }

  get isIOS(): boolean {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
    );
  }

  // Static property to store retailer ID retrieved from local storage
  static retailerId: number = Number(localStorage.getItem("retailer_id")); //3;//63;
  // Function to show/hide loader based on flag value
  hideShowLoader(flag: boolean) {
    this.showLoader.next(flag);
  }
  // Function to add an item to the shopping basket
  addItemToBasket(newbasket: Basket) {
    sessionStorage.setItem("mybasket", JSON.stringify(newbasket));

    if (newbasket?.items?.length > 0) {
      this.basketService.StoreBasketItem(newbasket)?.subscribe((resp) => {
        console.log(resp.message);
      });
    } else {
      this.basketService.DeleteBasketItem()?.subscribe((resp) => {
        console.log(resp.message);
      });
    }

    return this.basketSubject.next(newbasket);
  }
  // Function to add a delivery fee item to the shopping basket
  addDeliveryFeeItemToBasket(NewItem: BasketItem) {
    this.currentBasket.items.push(NewItem);
    var basketTotal = this.currentBasket.items.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0,
    );
    var disbasketTotal = this.currentBasket.items
      .filter((x) => !x.is_promo_exclude)
      .reduce((sum, item) => sum + item.price * item.quantity, 0);

    const avgVat =
      this.currentBasket.items
        .filter((x) => x.price > 0)
        .reduce((sum, item) => sum + item.vat_rate, 0) /
      this.currentBasket.items.filter((x) => x.price > 0).length;
    var basketVATTotal = (basketTotal * avgVat) / 100;
    var basketTotalLessVAT = basketTotal - basketVATTotal;

    var newbasket = {
      ...this.currentBasket,
      items: this.currentBasket.items,
      retailerId: CoreService.retailerId,
      discountableTotal: disbasketTotal,
      orderTotal: basketTotal,
      orderTotalLessVAT: basketTotalLessVAT,
      totalPayableAmount:
        this.currentBasket?.totalPayableAmount + NewItem?.totalprice,
      VATAmt: basketVATTotal,
    };
    sessionStorage.setItem("mybasket", JSON.stringify(newbasket));
    return this.basketSubject.next(newbasket);
  }
  // Function to remove a delivery fee item from the shopping basket
  removeDeliveryFeeItemToBasket() {
    if (this.currentBasket && this.currentBasket.items.length > 0) {
      var deliveryItem = this.currentBasket.items.filter(
        (x) => x.is_delivery_fee_product,
      );

      this.currentBasket.items = this.currentBasket.items.filter(
        (x) => !x.is_delivery_fee_product,
      );

      var basketTotal = this.currentBasket.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0,
      );
      var disbasketTotal = this.currentBasket.items
        .filter((x) => !x.is_promo_exclude)
        .reduce((sum, item) => sum + item.price * item.quantity, 0);

      const avgVat =
        this.currentBasket.items
          .filter((x) => x.price > 0)
          .reduce((sum, item) => sum + item.vat_rate, 0) /
        this.currentBasket.items.filter((x) => x.price > 0).length;
      var basketVATTotal = (basketTotal * avgVat) / 100;
      var basketTotalLessVAT = basketTotal - basketVATTotal;
      var newbasket = {
        ...this.currentBasket,
        items: this.currentBasket.items,
        retailerId: CoreService.retailerId,
        discountableTotal: disbasketTotal,
        orderTotal: basketTotal,
        orderTotalLessVAT: basketTotalLessVAT,
        VATAmt: basketVATTotal,
        totalPayableAmount:
          this.currentBasket?.totalPayableAmount -
          (deliveryItem?.length > 0 ? deliveryItem[0]?.totalprice : 0),
      };
      sessionStorage.setItem("mybasket", JSON.stringify(newbasket));
      return this.basketSubject.next(newbasket);
    }
  }
  // Function to clear the shopping basket
  clearBasket(clearhistory: any = true) {
    this.basketSubject.next(null);
    localStorage.removeItem("selected_location");
    sessionStorage.removeItem("mybasket");
    sessionStorage.removeItem("selectedMixAndMatch");
    sessionStorage.removeItem("displayedMixAndMatchList");

    if (clearhistory) {
      this.basketService.DeleteBasketItem()?.subscribe((resp) => {
        console.log(resp.message);
      });
    }
  }
  // Function to extract the domain from a URL
  getDomain(str) {
    if (str.includes("www.")) {
      var temp = str.split(".");
      return temp[0] + "." + temp[1];
    } else {
      return str.split(".")[0];
    }
  }
  // Function to get raw data using the apiService
  getRawData() {
    return this.apiService.getRawData();
  }
  // Function to construct merchant request data
  getmerchantReqData(domain = "", multi_id = "", last_shown_notification_id = "") {
    let Hostname = "";
    if (domain != "") Hostname = domain;
    else Hostname = window.location.hostname;
    let Subdomainname = this.getDomain(Hostname);
    let Device = this.GetOperatingSystem();
    //  if (Hostname == "192.168.1.121")
    //    return "localhost" + "?device_type=" + Device;
    // Subdomainname = "roseplaza"; // Multi Outlet (venue)
    // Subdomainname = "hideaways"; // Multi Outlet (venue)
    // Subdomainname = "milkandmadu"; // Single Outlet (Retailer)s
    // Subdomainname = "demomicrodelivery"; // Single Outlet (Retailer)
    // Subdomainname = "teawala";
    // Subdomainname = "millenniumatria";
    // Subdomainname = "freshbasketpalmjumeirah"
    // Subdomainname = "tiararesidents";
    // Subdomainname = "v-palmjumeirah";

    const params = new URLSearchParams(window.location.search);
    params.set("device_type", Device);

    if (multi_id) {
      params.set("multi_outlet_id", multi_id);
    }

    if (last_shown_notification_id) {
      params.set("last_shown_notification_id", last_shown_notification_id);
    }

    return Subdomainname + "?" + params.toString();
  }
  // Function to fetch merchant data using the apiService
  getMerchanrData(data): Observable<any> {
    // return this.apiService.get(API.GET_SUBDOMAIN_DATA + data);
    // var responseData: any;
    this.apiService.get("get-location/" + data).subscribe((responseData) => {
      if (responseData?.data?.location_from == MultiOutletLocation.FromUser) {
        var locationData = this.getLocation().then((data) => {
          if (this.locationData) {
            return this.apiService.get(
              API.GET_SUBDOMAIN_DATA +
                data +
                "&latitude=" +
                this.locationData[0] +
                "&longitude=" +
                this.locationData[1],
            );
          }
        });
      } else {
        return this.apiService.get(API.GET_SUBDOMAIN_DATA + data);
      }
    });

    return this.apiService.get(API.GET_SUBDOMAIN_DATA + data);
    // if (responseData?.is_user_location) {
    //   var data1 = this.getLocation().then((data) => {});
    //   if (this.locationData) {
    //     return this.apiService.get(
    //       API.GET_SUBDOMAIN_DATA +
    //         data +
    //         "&latitude=" +
    //         this.locationData[0] +
    //         "&longitude=" +
    //         this.locationData[1]
    //     );
    //   }
    // } else {
    //   return this.apiService.get(API.GET_SUBDOMAIN_DATA + data);
    // }

    // var data1 = this.getLocation().then((data) => {
    // });

    // if(this.locationData)
    //   {
    //     return this.apiService.get(API.GET_SUBDOMAIN_DATA + data +  '&latitude='+ this.locationData[0]+ '&longitude='+ this.locationData[1]);
    //   }
    //   else{
    //     return this.apiService.get(API.GET_SUBDOMAIN_DATA + data);
    //   }
  }

  async getLocation() {
    await this.commonService
      .getUserLocation("25.2048", "25.2048")
      .then((data) => {
        this.locationData = data;
      });
  }

  //Function to fetch merchant outlet category using the apiService
  getMerchantCategoryData(data) {
    return this.apiService.get(
      "multi-outlet-categories-list?" + "multi_outlet_id=" + data,
    );
  }

  getMerchantDataByCategory(
    outletId,
    categoryId,
    lat,
    long,
    retailerId,
    isPinned,
    ignoreNotificationIds?: string,
  ) {
    let apiUrl =
      "get-retailer-by-categories?multi_outlet_id=" +
      outletId +
      "&category_id=" +
      categoryId +
      "&latitude=" +
      lat +
      "&longitude=" +
      long +
      "&retailer_id=" +
      retailerId +
      "&is_pinned=" +
      isPinned;

    if (ignoreNotificationIds) {
      apiUrl += "&ignore_notification_ids=" + ignoreNotificationIds;
    }

    return this.apiService.get(apiUrl);
    // return this.apiService.get(API.RETAILERS + "?category_id=" + data);
  }

  // Function to determine the operating system of the device
  GetOperatingSystem() {
    // Get the user agent string from the browser or vendor
    var userAgent = navigator.userAgent || navigator.vendor;

    // Check if the device is running on Android
    if (/android|X11/i.test(userAgent)) {
      return "a"; // Return 'a' for Android
    }

    // Check if the device is running on iOS (iPad, iPhone, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "i"; // Return 'i' for iOS
    }

    // Check if the device operating system is Windows (for laptops and PCs)
    if (userAgent.indexOf("Win") != -1) {
      return "a"; // Return 'a' for Windows (assumed Android-like behavior)
    }

    // Check if the device operating system is macOS (for laptops and PCs)
    if (userAgent.indexOf("Mac") != -1) {
      // Check specific browsers within macOS
      if (userAgent.indexOf("Chrome") != -1)
        return "a"; // Return 'a' for Chrome on macOS
      else if (userAgent.indexOf("Safari") != -1) return "i"; // Return 'i' for Safari on macOS
    }
  }
  // Function to navigate to a specific path with optional parameters
  navigateTo(path, params = null, preserveQueryParams = false) {
    if (params) {
      this.router.navigate([path], {
        queryParams: params,
        queryParamsHandling: preserveQueryParams ? "merge" : null,
      });
    } else {
      this.router.navigate([path], {
        queryParamsHandling: preserveQueryParams ? "merge" : null,
      });
    }
  }
  // Function to calculate total price for a product
  GetTotalprice(product): number {
    var Total: number = 0;

    Total = Number(Number(product.price) * Number(product.quantity ?? 1));
    return Total;
  }
  // Function to fetch country data using the apiService
  getCountry(): Observable<any> {
    return this.apiService.get(API.COUNTRY);
  }
  // Function to create a dynamic PWA manifest
  // CreateDynamicPWAManifest(name, logo, bgColor, themeColor, startURl) {
  //   // Construct a dynamic manifest for Progressive Web App (PWA)
  //   var myDynamicManifest = {
  //     // Set the name of the app as well as the short name (displayed on homescreen)
  //     name: name,
  //     short_name: name,
  //     // Define the display mode of the PWA (standalone means it runs as a standalone app)
  //     display: "standalone",

  //     // Set the orientation of the app (portrait)
  //     orientation: "portrait",

  //     // Define the start URL when the app is launched
  //     start_url: startURl,

  //     // Specify the background color of the app
  //     background_color: bgColor,

  //     // Specify the theme color that affects the browser's UI when the app is launched
  //     theme_color: themeColor,

  //     // Define an array of icons in different sizes and types
  //     icons: [
  //       {
  //         src: logo,
  //         sizes: "48x48",
  //         type: "image/png",
  //       },
  //       {
  //         src: logo,
  //         sizes: "72x72",
  //         type: "image/png",
  //       },
  //       {
  //         src: logo,
  //         sizes: "96x96",
  //         type: "image/png",
  //       },
  //       {
  //         src: logo,
  //         sizes: "144x144",
  //         type: "image/png",
  //       },
  //       {
  //         src: logo,
  //         sizes: "192x192",
  //         type: "image/png",
  //       },
  //       {
  //         src: logo,
  //         sizes: "256x256",
  //         type: "image/png",
  //       },
  //       {
  //         src: logo,
  //         sizes: "384x384",
  //         type: "image/png",
  //       },
  //       {
  //         src: logo,
  //         sizes: "512x512",
  //         type: "image/png",
  //       },
  //     ],
  //   };

  //   // Convert the manifest object to a JSON string
  //   const stringManifest = JSON.stringify(myDynamicManifest);

  //   // Create a Blob (Binary Large Object) containing the JSON string
  //   const blob = new Blob([stringManifest], { type: "application/json" });

  //   // Generate a URL for the Blob object
  //   const manifestURL = URL.createObjectURL(blob);
  //   // Get the meta tag element
  //   const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  //   // Set the content attribute dynamically based on your logic
  //   const userPreferredColor = themeColor; // Replace this with your logic
  //   if (themeColorMeta) {
  //     themeColorMeta.setAttribute("content", userPreferredColor);
  //   }
  //   // Set the "href" attribute of the element with ID "my-manifest-placeholder" to the generated manifest URL
  //   document
  //     .querySelector("#my-manifest-placeholder")
  //     .setAttribute("href", manifestURL);
  // }

  CreateDynamicPWAManifest(name, logo, bgColor, themeColor, startURl) {
    console.log("=========== PWA MANIFEST START ===========");

    console.log("PWA Name:", name);
    console.log("PWA Logo:", logo);
    console.log("PWA Background Color:", bgColor);
    console.log("PWA Theme Color:", themeColor);
    console.log("PWA Start URL:", startURl);
    console.log("Window Origin:", window.location.origin);
    console.log("Current URL:", window.location.href);

    // Construct a dynamic manifest for Progressive Web App (PWA)
    var myDynamicManifest = {
      // Set the name of the app as well as the short name
      name: name,
      short_name: name,

      // Display mode
      display: "standalone",

      // Orientation
      orientation: "portrait",

      // Start URL
      start_url: startURl,

      // Background color
      background_color: bgColor,

      // Theme color
      theme_color: themeColor,

      // Icons
      icons: [
        {
          src: logo,
          sizes: "48x48",
          type: "image/png",
        },
        {
          src: logo,
          sizes: "72x72",
          type: "image/png",
        },
        {
          src: logo,
          sizes: "96x96",
          type: "image/png",
        },
        {
          src: logo,
          sizes: "144x144",
          type: "image/png",
        },
        {
          src: logo,
          sizes: "192x192",
          type: "image/png",
        },
        {
          src: logo,
          sizes: "256x256",
          type: "image/png",
        },
        {
          src: logo,
          sizes: "384x384",
          type: "image/png",
        },
        {
          src: logo,
          sizes: "512x512",
          type: "image/png",
        },
      ],
    };

    console.log("Generated Manifest Object:", myDynamicManifest);

    // Convert the manifest object to JSON string
    const stringManifest = JSON.stringify(myDynamicManifest);

    console.log("Manifest JSON String:", stringManifest);

    // Create Blob
    const blob = new Blob([stringManifest], {
      type: "application/json",
    });

    console.log("Manifest Blob:", blob);

    // Generate Blob URL
    const manifestURL = URL.createObjectURL(blob);

    console.log("Generated Manifest URL:", manifestURL);

    // Get meta tag
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');

    console.log("Theme Color Meta Element:", themeColorMeta);

    // Set theme color dynamically
    const userPreferredColor = themeColor;

    if (themeColorMeta) {
      themeColorMeta.setAttribute("content", userPreferredColor);

      console.log("Theme color updated successfully:", userPreferredColor);
    } else {
      console.warn("Theme color meta tag not found");
    }

    // Get manifest link element
    const manifestElement = document.querySelector("#my-manifest-placeholder");

    console.log("Manifest Link Element:", manifestElement);

    if (manifestElement) {
      manifestElement.setAttribute("href", manifestURL);

      console.log("Manifest href updated successfully:", manifestURL);
    } else {
      console.error("Manifest placeholder element not found");
    }

    let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (!appleTouchIcon) {
      appleTouchIcon = document.createElement("link");
      appleTouchIcon.setAttribute("rel", "apple-touch-icon");
      document.head.appendChild(appleTouchIcon);
    }
    appleTouchIcon.setAttribute("href", logo);

    console.log(
      "Final Manifest Link Href:",
      manifestElement?.getAttribute("href"),
    );

    console.log("=========== PWA MANIFEST END ===========");
  }
}
// Extend the Window interface to include MSStream property
declare global {
  interface Window {
    MSStream: any;
  }
}
